import { type ActionType, createAction, getType } from "typesafe-actions";

type Tours = "PROJECT_OVERVIEW" | "CALENDAR_OVERVIEW";

export interface UserTourState {
  currentTour: Tours;
  currentStep: number;
  isRunning: boolean;
  projectOverview: {
    openTeamsModal: boolean;
  };
}

export const UserTourStateDefault: UserTourState = {
  currentTour: "PROJECT_OVERVIEW",
  currentStep: 0,
  isRunning: false,
  projectOverview: {
    openTeamsModal: false,
  },
};

export const UserTourStateCalendar: UserTourState = {
  currentTour: "CALENDAR_OVERVIEW",
  currentStep: 0,
  isRunning: false,
  projectOverview: {
    openTeamsModal: false,
  },
};

export type UserTourStateActions = typeof userTourStateActions;

export const userTourStateActions = {
  setCurrentTour: createAction("SET_CURRENT_TOUR")<Tours>(),
  setStep: createAction("SET_STEP")<number>(),
  setIsRunning: createAction("SET_IS_RUNNING")<boolean>(),
  setPreviousStep: createAction("SET_PREV_STEP")<boolean>(),
  projectOverviewOpenModal: createAction("SET_OPEN_TEAMS_MODAL")<boolean>(),
};

export function reducer(
  state: UserTourState,
  action: ActionType<UserTourStateActions>
): UserTourState {
  switch (action.type) {
    case getType(userTourStateActions.setCurrentTour):
      return {
        ...state,
        currentTour: action.payload,
      };
    case getType(userTourStateActions.setStep):
      return {
        ...state,
        currentStep: action.payload,
      };
    case getType(userTourStateActions.projectOverviewOpenModal):
      return {
        ...state,
        projectOverview: {
          ...state.projectOverview,
          openTeamsModal: action.payload,
        },
      };
  }

  return state;
}
